
/**
 * @description
 * 로드맵 상세 > 요약 > 타이틀
 */

import { mapGetters } from 'vuex';

export default {
  name: 'CourseSummaryTitle',
  computed: {
    ...mapGetters('course', ['title']),
  },
};
